<template>
  <button @click="emitOpen" class="btn btn-outline-primary btn-price-alert">
    <i class="bi" :class="hasAlert ? 'bi-bell-fill' : 'bi-bell'"></i>
  </button>
</template>

<script>
export default {
  name: 'PriceAlertButton',
  props: {
    hasAlert: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitOpen() {
      this.$emit('open-modal');
    }
  }
}
</script>

<style scoped>
.btn-price-alert {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: #fff;
  color: #1E3A8A;
  border: 1px solid #1E3A8A;
  transition: all 0.2s ease;
  padding: 0;
}

.btn-price-alert:hover {
  background-color: #e6ebf5;
  color: #1E3A8A;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-price-alert i {
  color: #1E3A8A;
  font-size: 1.2rem;
}
</style>
